<div class="container">
  <div class="label">
    {{ label }}
    <div class="required-mark" *ngIf="required"></div>
  </div>
  <div class="input-box" [class.is-nickname]="isNickname">
    <div class="input-wrapper">
      <div class="input">
        <ng-content select="textarea, input"></ng-content>
      </div>
      <span *ngIf="isNickname" class="nickname-label mobile">그룹책</span>
    </div>
    <ng-content></ng-content>
    <div class="hint">
      <ng-content select="lib-reading-group-form-field-hint"></ng-content>
    </div>
  </div>
  <span *ngIf="isNickname" class="nickname-label desktop">그룹책</span>
</div>
